import { ItemCustomLink } from "@dto/customLinks.dto";
import { ColorUtil } from "src/util/ColorUtil";
import "./CustomLink.less";

const CustomLink = ({ url, color, label }: Omit<ItemCustomLink, 'item'>) => {
  const nUrl = normalizedUrl(url);
  return <a href={nUrl} target='_blank' rel={'noopener noreferrer'}
    className="xm-custom-link"
    style={{ background: color, color: ColorUtil.contrastText(color), padding: '0.125em 0.5em', borderRadius: '0.25em' }}>
    {label}
  </a>;
};

export const normalizedUrl = (url: string): string => {
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('//')) return `https:${url}`;
  return `https://${url}`;
};

export default CustomLink;